import React from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import DanhSachQuyKhacApi from "service/DanhSachQuyKhacApi";

const XoaQuyKhac = ({ ThuChiId, onClose, loadDanhSachQuyKhac }) => {
    const handleConfirm = () => {
        onDelete(ThuChiId);
    };
    const onDelete = async (ThuChiId) => {
        try {
            await DanhSachQuyKhacApi.deleteQuyKhac({ ThuChiId });
            pushNotification("Xóa thành công!", "success", "TOP_CENTER", 1000);
            onClose();
            loadDanhSachQuyKhac();
        } catch (err) {
            console.error("Lỗi khi xóa:", err);
            pushNotification("Không thể xóa. Vui lòng thử lại!", "error", "TOP_CENTER", 1000);
        }
    }
    return (
        <Modal
            show={true}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title" id="myModalLabel16">
                    <span className="btn-icon-right">
                        <i className="mdi mdi-delete"></i>
                    </span>
                    Xác nhận xoá
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onClose}
                >
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="">
                <form className="form tat-toan form-horizontal">
                    <div className="form-body">
                        <div className="form-body">
                            <div className="form-group row">
                                <label
                                    className="col-md-12 label-control text-left"
                                    for="projectinput2"
                                >
                                    Bạn có chắc chắn muốn xóa không?
                                </label>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-checknew"
                    onClick={handleConfirm}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-check"></i>
                    </span>
                    Xác nhận
                </button>

                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onClose}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default XoaQuyKhac;